// ArtifactIndicator — a small "this chat has artifacts" chip (filled Widgets glyph + count) shown on
// chat rows in the rail, the Chats page, and the project Add-chat picker. Renders nothing when the
// chat has no artifacts, so it only ever draws attention to chats that produced a deliverable.

import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import WidgetsIcon from '@mui/icons-material/Widgets'

const CYAN = '#008FA8'

export function ArtifactIndicator({ count }: { count?: number }) {
  if (!count) return null
  return (
    <Tooltip title={`${count} artifact${count === 1 ? '' : 's'}`}>
      <Box sx={{
        flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 0.3,
        px: 0.6, height: 18, borderRadius: 999,
        bgcolor: `${CYAN}14`, color: CYAN, fontSize: '0.65rem', fontWeight: 700,
      }}>
        <WidgetsIcon sx={{ fontSize: 12 }} />
        {count}
      </Box>
    </Tooltip>
  )
}

export default ArtifactIndicator
